var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_1",
    "data-name": "Arrow 1",
    transform: "translate(22374 17622)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(-22374 -17622)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-22365 -17615.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_left-_335_",
    "data-name": "arrow_left-[#335]",
    d: "M295.244,6519.171h0a.619.619,0,0,0-.86,0l-5.028,4.9a1.155,1.155,0,0,0,0,1.669l5.064,4.932a.625.625,0,0,0,.854.006h0a.586.586,0,0,0,.006-.847l-4.635-4.5a.584.584,0,0,1,0-.84l4.6-4.47a.584.584,0,0,0,0-.84",
    transform: "translate(-289 -6518.998)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.9ea89e3211b679bd9038685415a441e0.svg";
export { ForwardRef as ReactComponent };